(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["church-directory"] && !Shopify.designMode) return;
  try {
    
  // Client-side name filter. The search box is rendered hidden and only
  // revealed here, so a visitor with JS disabled never sees a control
  // that would do nothing for them — the full directory still renders
  // server-side either way.
  (function () {
    document.querySelectorAll('[data-church-grid]').forEach(function (grid) {
      var scope = grid.closest('.church-directory');
      if (!scope) return;

      var wrap = scope.querySelector('[data-church-search-wrap]');
      var input = scope.querySelector('[data-church-search]');
      var noResults = scope.querySelector('[data-church-no-results]');
      var cards = Array.prototype.slice.call(grid.querySelectorAll('[data-church-item]'));

      if (!wrap || !input || cards.length === 0) return;
      wrap.hidden = false;

      input.addEventListener('input', function () {
        var q = input.value.trim().toLowerCase();
        var visible = 0;

        cards.forEach(function (card) {
          var name = card.getAttribute('data-church-name') || '';
          var match = q === '' || name.indexOf(q) !== -1;
          card.hidden = !match;
          if (match) visible++;
        });

        if (noResults) noResults.hidden = visible !== 0;
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('.nav-toggle').forEach(function (toggle) {
    var links = toggle.closest('.main-nav').querySelector('.nav-links');
    if (!links) return;
    toggle.addEventListener('click', function () {
      var expanded = toggle.getAttribute('aria-expanded') === 'true';
      toggle.setAttribute('aria-expanded', String(!expanded));
      links.classList.toggle('open');
    });
  });

  // Mini-cart hover dropdown. Only wired up on devices that genuinely
  // support hover — matchMedia('(hover: hover)') is false on touch
  // devices, so tapping the cart icon there just navigates to /cart
  // normally instead of trying to open a preview that doesn't suit tap.
  if (window.matchMedia && window.matchMedia('(hover: hover)').matches) {
    var wrapper = document.querySelector('[data-cart-dropdown-wrapper]');
    if (wrapper) {
      var cartLink = wrapper.querySelector('[data-cart-link]');
      var dropdown = wrapper.querySelector('[data-cart-dropdown]');
      var itemsEl = wrapper.querySelector('[data-cart-dropdown-items]');
      var subtotalEl = wrapper.querySelector('[data-cart-dropdown-subtotal]');
      var hideTimer;
      var MAX_VISIBLE = 4;

      function formatMoney(cents) {
        return '$' + (cents / 100).toFixed(2);
      }

      function renderDropdown(cart) {
        if (!cart.items.length) {
          itemsEl.innerHTML = '<p class="cart-dropdown__empty">Your cart is empty.</p>';
          subtotalEl.textContent = formatMoney(0);
          return;
        }

        var visible = cart.items.slice(0, MAX_VISIBLE);
        var extra = cart.items.length - visible.length;

        itemsEl.innerHTML = visible
          .map(function (item) {
            var img = item.image
              ? '<div class="cart-dropdown__thumb"><img src="' + item.image + '" alt="" loading="lazy"></div>'
              : '<div class="cart-dropdown__thumb"></div>';
            var variant =
              item.variant_title && item.variant_title !== 'Default Title'
                ? '<div class="cart-dropdown__meta">' + item.variant_title + ' · Qty ' + item.quantity + '</div>'
                : '<div class="cart-dropdown__meta">Qty ' + item.quantity + '</div>';
            return (
              '<div class="cart-dropdown__line">' +
              img +
              '<div class="cart-dropdown__info">' +
              '<div class="cart-dropdown__title">' + item.product_title + '</div>' +
              variant +
              '</div>' +
              '</div>'
            );
          })
          .join('');

        if (extra > 0) {
          itemsEl.innerHTML +=
            '<div class="cart-dropdown__more">+ ' + extra + ' more item' + (extra === 1 ? '' : 's') + '</div>';
        }

        subtotalEl.textContent = formatMoney(cart.total_price);
      }

      function openDropdown() {
        clearTimeout(hideTimer);
        fetch('/cart.js')
          .then(function (res) {
            return res.json();
          })
          .then(function (cart) {
            renderDropdown(cart);
            dropdown.hidden = false;
            cartLink.setAttribute('aria-expanded', 'true');
          })
          .catch(function () {
            // If this fails, the cart link still works as a normal
            // link to /cart — the dropdown is a bonus, not required.
          });
      }

      function scheduleClose() {
        clearTimeout(hideTimer);
        hideTimer = setTimeout(function () {
          dropdown.hidden = true;
          cartLink.setAttribute('aria-expanded', 'false');
        }, 200);
      }

      wrapper.addEventListener('mouseenter', openDropdown);
      wrapper.addEventListener('mouseleave', scheduleClose);
    }
  }

  } catch(e) { console.error(e); }
})();
})();
